import React from 'react'
import "./Invoice.css"
import {AiFillPhone} from "react-icons/ai";
import {BsEnvelopeFill} from "react-icons/bs"
import {AiFillHome} from "react-icons/ai";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import  redCliffeLogo from "../Assets/redCliffeLogo.png"

const Invoice = () => {
    const handleClick= ()=>{
      html2canvas(document.querySelector("#divToPrint"),{scale: 1.0,}).then(canvas => {
        const imgData = canvas.toDataURL('image/png',1.0);
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', .1, 0);
        pdf.save("download.pdf"); 
    });
  }

    return (
        <div style={{  marginTop: "5rem", marginInline: "40rem", marginRight: "72.7rem",}}>
        <div id="divToPrint">
          <hr style={{  border: "5px solid #e2124f",width: "100%"}}/>
          <div style={{ display: "flex",marginTop: "2rem",justifyContent: "space-between",alignItems: "center",
              paddingInline: "2rem"}} >
            <img style={{height: "40px"}}
                  src={redCliffeLogo}
                />
  
              <span style={{  fontSize: "30px",fontWeight: "700"}} >Invoice</span>
          </div>
          <div style={{display: "grid",gridTemplateColumns: "8vw 1.2fr 1fr 1.8fr 0.8fr",marginTop: "1rem",}}>
            <div style={{ border: "2px solid rgba(214, 209, 209, 0.8)",paddingBlock: "6px",fontSize: "14px",fontWeight: "400", textAlign: "center", borderLeft: "none"}}>
              INVOICE NO.
              <div style={{  fontSize: "16px",fontWeight: "600",padding: "1rem"}} >
                1234567890
              </div>
            </div>
            <div style={{  border: "2px solid rgba(214, 209, 209, 0.8)",paddingBlock: "6px", fontSize: "14px",
                fontWeight: "400",textAlign: "center",borderLeft: "none"}}>
              INVOICE DATE
              <div style={{fontSize: "16px",fontWeight: "600",padding: "1rem"}}>
                Dec 30, 2021
              </div>
            </div>
            <div style={{ border: "2px solid rgba(214, 209, 209, 0.8)",paddingBlock: "6px", fontSize: "14px",
                fontWeight: "400",textAlign: "center",borderLeft: "none"}}>
              BOOKING ID
              <div style={{fontSize: "16px",fontWeight: "600",padding: "1rem"}}>
                1234567890
              </div>
            </div>
            <div style={{border: "2px solid rgba(214, 209, 209, 0.8)",paddingBlock: "6px", fontSize: "14px",
                fontWeight: "400",textAlign: "center",borderLeft: "none"}}>
              SAMPLE COLLECTION DATE
              <div style={{fontSize: "16px",fontWeight: "600",padding: "1rem"}}>
                Dec 28, 2021
              </div>
            </div>
            <div style={{border: "2px solid rgba(214, 209, 209, 0.8)",paddingBlock: "6px", fontSize: "14px",  fontWeight: "400",textAlign: "center",borderLeft: "none",borderRight: "none"}} >
              SAC CODE
              <div style={{fontSize: "16px",fontWeight: "600",padding: "1rem"}}>
                1234567
              </div>
            </div>
          </div>
          <div style={{  display: "flex",paddingBlock: "2rem",paddingInline: "1rem", justifyContent: "space-between", alignItems: "flex-start", backgroundColor: "#f2fcff"}} >
            <div style={{fontSize: "14px"}}>
              <div style={{ color: "#11406b",fontWeight: "600", paddingBottom: "1.5rem"}}>BILL FORM</div>
              <div style={{padding: "0.5rem"}}>CIN Number:- <strong>U93000HR2013PTC051132</strong></div>
              <div style={{padding: "0.5rem"}}><strong>Redcliffe Labs</strong></div>
              <div style={{padding: "0.5rem"}}>H55 3rd Floor, Electronic City, Noida, Uttar Pradesh</div>
              <div style={{padding: "0.5rem"}}>GST No.: <strong>Not Applicable</strong></div>
            </div>
            <div style={{fontSize: "14px"}}>
              <div style={{ color: "#11406b",fontWeight: "600", paddingBottom: "1.5rem"}}>COSTOMER BILLING DETAILS</div>
              <div style={{padding: "0.5rem"}}><strong>JOHN DOE</strong></div>
              <div style={{padding: "0.5rem"}}>H55 3rd Floor, Electronic City, Noida, Uttar Pradesh</div>
            </div>
          </div>
          <hr />
          <div>
            <div style={{  display: "flex",fontSize: "16px",fontWeight: "600",justifyContent: "space-between",alignTtems: "flex-start",backgroundColor: "#f4f4f4",marginTop: "2rem",padding: "1rem"}}>
              <div>TEST DESCRIPTION</div>
              <div>AMOUNT</div>
            </div>
            <div style={{  padding: "1rem",fontWeight: "600", fontSize: "15px"}}>
              <p>John Doe</p> 
              <hr/>
            </div>
            <div style={{  display: "flex", justifyContent: "space-between",color: "black !important",fontSize: "16px",paddingLeft: "2rem !important",paddingInline: "1rem"}} >
              RTPCR Test
              <div><strong>&#x20B9;1000</strong></div>
            </div>
            <div style={{  display: "flex",fontSize: "16px",justifyContent: "space-between",alignItems: "flex-start",backgroundColor: "#fbfbfb",marginTop: "1rem",padding: "1rem"}} >
              <div>Total Amount</div>
              <div>&#x20B9;1000</div>
            </div>
            <hr />
            <div style={{  display: "flex",fontSize: "16px",fontWeight: "600",justifyContent: "space-between",alignItems: "flex-start",padding: "1rem"}}>
              <div>Grand Total</div>
              <div>&#x20B9;1000</div>
            </div>
            <div style={{  display: "flex",fontSize: "16px",fontWeight: "600",justifyContent: "space-between",alignItems: "flex-start",backgroundColor: "#f4f4f4",padding: "1rem"}}>
              <div>Paid Amount</div>
              <div>&#x20B9;1000</div>
            </div>
          </div>
          <div style={{  marginTop: "3rem",paddingInline: "1rem",display: "flex",justifyContent: "space-between",fontSize: "13px",lineHeight: "1.4"}} >
            <div>
              <strong>Amount Chargable (in words)</strong>
              <div>
                <i>Rupees One Thousand Only</i>
              </div>
              <div style={{  color: "#11406b",fontSize: "15px"}}>Company's PAN No. <span>HY45676545678B</span></div>
              <div>
                Please make cheques in favor of <strong>"Redcliffe Labs"</strong> 
              </div>
            </div>
            <div style={{ textAlign: "end"}}>
              <strong>Payment Mode Summary</strong>
              <table style={{  borderCollapse: "collapse",textAlign: "left",width: "100%",fontSize: "12px",marginTop: "1rem"}}>
                <tr style={{backgroundColor: "#f1f1f1"}}>
                  <td style={{  paddingInline: "2rem",paddingBlock: "1rem"}}>Payment Date</td>
                  <td style={{  paddingInline: "2rem",paddingBlock: "1rem"}}>Payment Mode</td>
                  <td style={{  paddingInline: "2rem",paddingBlock: "1rem"}}>Amount</td>
                </tr>
                <tr style={{backgroundColor: "#f9f9f9"}}>
                  <td style={{  paddingInline: "2rem",paddingBlock: "1rem"}}>2021-12-29</td>
                  <td style={{  paddingInline: "2rem",paddingBlock: "1rem"}}>Pos</td>
                  <td style={{  paddingInline: "2rem",paddingBlock: "1rem"}}>&#x20B9;1000</td>
                </tr>
              </table>
              <hr />
            </div>
          </div>
          <div style={{ marginTop: "1.6rem", paddingInline: "1px", fontSize: "12px", lineHeight: "1.4", backgroundColor: "#fbfbfb",marginBottom: "14rem"}}>
            <strong>Important Notes:</strong>
            <ul >
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>Redcliffe Labs Marketing Pvt Ltd is exempt from GST being a healthcare service provider</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>This invoice can be used for tax exemption under section 80-D (Preventive Health Checkup)</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>Reports sent on registered mail ID according to the respective TAT and can also be downloaded through healthians Application</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>All dispute / claims concerning to reports are subject to the courts of Noida</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>Healthians assumes no liability towards any delays beyond its control</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>It is recommended that you consult your treating Doctor/Physician before choosing any treatment based on your results.</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>This price is inclusive of Pre and post counselling by the Doctor for diagnosis, Sample Collection, Transportation, Pre-Analytical, Reporting, Interpretation ofresults and Diet & Nutrition advice for diagnosis and prevention of diseases.</li>
              <li style={{  fontStyle: "italic", marginInline: "1.4rem",listStyleType:"square"}}>Maximum liability of service provider would not exceed the amount charged by the service provider for the particular test(s)</li>
            </ul>
          </div>
          <div style={{textAlign: "center",fontSize: "10px",marginBottom: "1rem",}}>
            <i>* This is a computer generated receipt and does not require signature/stamp</i>
          </div>
          <div style={{  color: "#0a2d4e",display: "flex",fontSize: "15px",justifyContent: "space-between",alignItems: "flex-start", backgroundColor: "#e2124f",padding: "2.2rem"}}>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><AiFillPhone />&nbsp;898-898-8787</div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><BsEnvelopeFill/>&nbsp;care@redcliffelabs.com</div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><AiFillHome />&nbsp;https://redcliffelabs.com/</div>
          </div>
          <button style={{  color: "#11406b",fontSize: "15px"}} onClick={handleClick}>Print</button>
          </div>
        </div>
        
    )
}
export default {
  component: Invoice,
};